@let _conversations = conversations();
@let _isDropdownOpen = isDropdownOpen();
@let _activeIndex = activeButtonIndex();
@let _activeConversation = aida.conversation();

<div
	#MainElement
	class="ada-container ada-col-1 ada-colspan-1"
>
	<button
		#SelectButton
		aria-label="Select Chat"
		class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding ada-full-width ada-flex-justify-left llm-switch-select-btn"
		data-testid="llm-switch-select-chat-button"
		title="Select Chat"
		[class.ada-is-disabled]="isDisabled"
		(click)="toggleDropdown(!_isDropdownOpen)"
	>
		<span
			ada-color="foreground"
			class="conversation-name"
		>
			{{ _activeConversation?.displayName }}
		</span>
		<ada-icon
			ada-color="foreground"
			icon="faAngleDownOutline"
		/>
	</button>
	<div
		#Dropdown
		popover="auto"
		[ngStyle]="dropdownStyle()"
		(toggle)="closeDropdown($event.newState === 'closed')"
	>
		@for (_chat of _conversations; track _chat.objectId; let i = $index) {
			<ng-container *ngTemplateOutlet="ChatButton; context: { chat: _chat, index: i }" />
		}
		<button
			ada-background-color="background"
			ada-color="foreground"
			aria-label="New Chat"
			class="ada-btn ada-btn-flat ada-btn-no-margin ada-btn-no-padding ada-full-width ada-border-inner-bottom llm-switch-dropdown-btn"
			data-testid="llm-switch-new-chat-btn"
			title="New Chat"
			[class.ada-is-disabled]="isDisabled"
			(click)="createNewConversation()"
		>
			<span>New Chat</span>
		</button>
		<button
			ada-background-color="background"
			ada-color="foreground"
			aria-label="View All Chats"
			class="ada-btn ada-btn-flat ada-btn-no-margin ada-btn-no-padding ada-full-width llm-switch-dropdown-btn"
			data-testid="llm-switch-view-all-btn"
			title="View All Chats"
			[class.ada-is-disabled]="isDisabled"
			(click)="viewAllChats()"
		>
			<span>View All Chats</span>
		</button>
	</div>
</div>

<ng-template
	#ChatButton
	let-chat="chat"
	let-index="index"
>
	<button
		ada-background-color="background"
		ada-color="foreground"
		attr.data-testid="{{ 'llm-switch-conversation-button-' + index }}"
		class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding ada-full-width llm-switch-dropdown-btn llm-switch-dropdown-chat-btn ada-border-inner-bottom"
		[class.ada-is-disabled]="isDisabled"
		(click)="selectConversation(chat)"
		(mouseenter)="activeButtonIndex.set(index)"
		(mouseleave)="activeButtonIndex.set(null)"
	>
		<div class="ada-display-flex ada-flex-direction-column ada-flex-align-start body">
			<div class="ada-flex-center header">
				<ada-icon
					ada-color="primary"
					icon="faCommentAlt"
				/>
				<span
					ada-color="foreground"
					class="ada-font-weight-bold conversation-name"
				>
					{{ chat.displayName }}
				</span>
			</div>
			<div class="ada-flex-center footer">
				<span class="ada-type-small">{{ chat.lastModificationTime | adaElapsedTime: 2 | async }} ago</span>
				<span>&#x2022;</span>
				<span class="ada-type-small">{{ chat.numForks }} {{ chat.numForks === 0 || chat.numForks > 1 ? 'forks' : 'fork' }}</span>
			</div>
		</div>
		@if (_activeIndex === index) {
			<div class="menu ada-display-flex">
				<button
					aria-label="Rename Chat"
					attr.data-testid="{{ 'llm-switch-rename-chat-button-' + index }}"
					class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
					title="Rename Chat"
					(click)="onRenameClick($event, chat)"
				>
					<ada-icon
						ada-color="primary"
						icon="faPenToSquareOutline"
					/>
				</button>
				<button
					aria-label="Delete Chat"
					attr.data-testid="{{ 'llm-switch-delete-chat-button-' + index }}"
					class="ada-btn ada-btn-sm ada-btn-icon ada-btn-flat ada-btn-no-margin ada-btn-no-padding"
					title="Delete Chat"
					(click)="onDeleteClick($event, chat)"
				>
					<ada-icon
						ada-color="error"
						icon="faTrashCanOutline"
					/>
				</button>
			</div>
		}
	</button>
</ng-template>
